import OrganizationDetails from "./OrganizationDetails";
export default OrganizationDetails;
